import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

import ROUTES from '../../routes';
import api from '../../config/axiosInstance';

import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';

function AddWarehouse() {
    const formRef = useRef(null);
    const navigate = useNavigate();

    const [title, setTitle] = useState('');
    const [location, setLocation] = useState('');
    const [locationIframe, setLocationIframe] = useState('');


    const [submitting, setSubmitting] = useState(false);

    const handleFormSubmit = async () => {
        const $ = window.jQuery;
        const form = $(formRef.current);

        if (form.valid()) {
            setTitle('');
            setLocation('');
            setLocationIframe('');

            $(form)
                .find('.is-valid, .is-invalid')
                .removeClass('is-valid is-invalid');

            $(form)
                .find('label.error, .invalid-feedback')
                .remove();

            const payload = { title, location, locationIframe };

            try {
                setSubmitting(true);
                const res = await api.post('/warehouse/create', payload);

                showToast('success', res.data.message, 'Success');
                navigate(ROUTES.WAREHOUSE);
            } catch (err) {
                handleErrors(err);
            } finally {
                setSubmitting(false);
            }
        }
    };

    useEffect(() => {
        const $ = window.jQuery;

        $.validator.addMethod('extension', function (value, element, allowedExtensions) {
            var fileName = value;
            var extension = fileName.split('.').pop().toLowerCase();
            return $.inArray(extension, allowedExtensions) !== -1;
        }, 'Invalid file type');

        $.validator.addMethod('validIframe', function (value, element) {
            return this.optional(element) || /^\s*<iframe[^>]*>[\s\S]*?<\/iframe>\s*$/i.test(value);
        }, 'Please enter a valid iframe tag.');

        if (formRef.current && $.fn.validate) {
            $(formRef.current).validate({
                rules: {
                    title: {
                        required: true,
                        maxlength: 200
                    },
                    location: {
                        required: true,
                        maxlength: 200
                    },
                    locationIframe: {
                        required: true,
                        maxlength: 1000,
                        validIframe: true
                    }
                },
                messages: {
                    title: {
                        required: "Please enter warehouse title",
                        maxlength: "Title cannot exceed 200 characters"
                    },
                    location: {
                        required: "Please enter warehouse location",
                        maxlength: "Location cannot exceed 200 characters"
                    },
                    locationIframe: {
                        required: "Please enter warehouse location iframe",
                        maxlength: "Location iframe cannot exceed 1000 characters",
                        validIframe: "Please enter a valid iframe tag"
                    }
                },
                ignore: [],
                errorElement: "label",
                validClass: "is-valid",
                errorClass: "is-invalid text-danger",
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(errorClass).addClass(validClass);
                }
            });
        }
    }, []);


    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.WAREHOUSE}>Warehouses</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={ROUTES.ADD_WAREHOUSE}>Add Warehouse</Link>
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Add Warehouse</h4>
                        </div>
                        <div className="card-body">
                            <form ref={formRef} noValidate>
                                <div className="row">
                                    <div className="mb-3 col-lg-6 col-md-6">
                                        <label className="form-label">Title<sup style={{ color: 'red' }}>*</sup></label>
                                        <input
                                            name="title"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ex. Warehouse 1"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-6 col-md-6">
                                        <label className="form-label">Location<sup style={{ color: 'red' }}>*</sup></label>
                                        <input
                                            name="location"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ex. Warehouse 1"
                                            value={location}
                                            onChange={(e) => setLocation(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-12 col-md-12">
                                        <label className="form-label">Location Iframe<sup style={{ color: 'red' }}>*</sup></label>
                                        <textarea
                                            name="locationIframe"
                                            className="form-control"
                                            placeholder="Ex. <iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3689.805780817445!2d75.86760337508938!3d15.32884988473876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbf137050f6810d%3A0x545427575942286d!2sPrime%20Autoz!5e0!3m2!1sen!2sin!4v1751322016490!5m2!1sen!2sin' width='600' height='450' style='border:0;' allowfullscreen='' loading='lazy' referrerpolicy='no-referrer-when-downgrade'></iframe>"
                                            value={locationIframe}
                                            onChange={(e) => setLocationIframe(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="pt-3">
                                    <button
                                        type="button"
                                        onClick={handleFormSubmit}
                                        className="btn btn-sm btn-primary me-2"
                                        disabled={submitting}
                                    >
                                        {submitting ? (
                                            <>
                                                <i className="spinner-border spinner-border-sm me-1"></i>
                                                Submit
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-floppy-disk me-1"></i>
                                                Submit
                                            </>
                                        )}
                                    </button>
                                    <Link to={ROUTES.WAREHOUSE} className="btn btn-sm btn-danger light">
                                        <i className="fas fa-times-circle"></i>&nbsp;
                                        Cancel
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddWarehouse;
